import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ModalTopBar from 'ui/ModalTopBar'
import getTexts from 'utils/localization'
import { ModalService } from 'services/ModalService'
import NewWithdraw from '@bet25/ui/NewWithdraw'
import UserAdapter from 'common/adapters/UserAdapter'
import NotificationConductor from 'common/conductors/NotificationConductor'
import BonusService from 'services/BonusService'
import { useHistory } from 'react-router'

import WithdrawHelper from '@bet25/ui/WithdrawHelper'
import { storeBankInfoHandler } from './helper'
import { USERS_WITH_CUSTOM_TRANSACTION_LIMIT } from '../../configs/main'
import UserService from 'services/UserService'
import UrlHistoryService from 'services/UrlHistoryService'
const {
    getWithdrawNotification,
    INFO_POPUP_TYPES,
    WITHDRAW_ID_ERRORS,
} = WithdrawHelper

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

const MIN_WITHDRAW_AMOUNT_CUSTOM = 1
const MIN_WITHDRAW_AMOUNT = 100

const Withdraw = ({ close, actions }) => {
    const [loading, setLoading] = useState(true)
    const history = useHistory()

    const [userReady, setUserReady] = useState(false)
    const [bonuses, setBonuses] = useState([])
    const [bonusesReady, setBonusesReady] = useState(false)
    const [userData, setUserData] = useState({})
    const [relatedGameId, setRelatedGameId] = useState('')
    const [storeBankInfoPending, setStoreBankInfoPending] = useState(false)

    const transferMoneyHandler = (amount) => {
        setLoading(true)
        UserAdapter.withdraw(amount)
            .then((res) => {
                if (!res.success) {
                    if (WITHDRAW_ID_ERRORS.includes(res.errorMessage)) {
                        const { title, message } = getWithdrawNotification(
                            res.errorMessage,
                            userData.bankAcc,
                            amount
                        )
                        NotificationConductor.error(message, title)
                        return
                    }

                    NotificationConductor.error(res.errorMessage)
                    return
                }

                UserService.setIsUserLoggedIn()

                const { messageKey, amount: responseAmount, success } = res.data

                // if (messageKey === 'ZIMPLER_PENDING') {
                //     ModalService.showModal('WITHDRAW_INFO_POPUP', {
                //         amount,
                //     })
                //
                //     return
                // }
                //
                // const { title, message } = getWithdrawNotification(
                //     messageKey,
                //     userData?.bankAcc,
                //     responseAmount
                // )

                if (success && INFO_POPUP_TYPES.includes(messageKey)) {
                    ModalService.showModal('WITHDRAW_INFO_POPUP', {
                        amount,
                        popupType: messageKey,
                    })
                } else {
                    const { title, message } = getWithdrawNotification(
                        messageKey,
                        userData.bankAcc,
                        responseAmount
                    )

                    NotificationConductor.error(message, title)
                }
                setLoading(false)
            })
            .catch((error) => {
                NotificationConductor.error(error.errorMessage)
                setLoading(false)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const getMinLimit = (user) => {
        return USERS_WITH_CUSTOM_TRANSACTION_LIMIT.includes(user.userId)
            ? MIN_WITHDRAW_AMOUNT_CUSTOM
            : MIN_WITHDRAW_AMOUNT
    }

    const getRedirectUrl = () => {
        ModalService.closeModal()

        if (relatedGameId) {
            history.push('/spil/' + relatedGameId + '/money/')
        } else {
            history.push('/alle-spil/slots')
        }
    }

    const onSelectPaymentTypeAction = (bankData, onSuccess) => {
        if (storeBankInfoPending || !bankData) {
            return
        }
        setStoreBankInfoPending(true)
        storeBankInfoHandler({
            bankData,
            onSuccessCallback: () => onSuccess(),
            checkSession: () => UserService.setIsUserLoggedIn(),
            onFinallyCallback: () => setStoreBankInfoPending(false),
        })
    }

    const onClickReadMore = (readMoreType) => {
        ModalService.showModal('WITHDRAW_READ_MORE', { readMoreType })
    }

    const onClickShowInfoModal = () => {
        ModalService.showModal('WITHDRAW_INFO_POPUP')
    }

    const onSelectPaymentTypeModal = (modalData) => {
        ModalService.showModal('WITHDRAW_SELECT_PAYMENT', {
            userData,
            modalData,
        })
    }

    const showConfirmationPopup = (modalData) => {
        ModalService.showModal('WITHDRAW_CONFIRM_POPUP', modalData)
    }

    useEffect(() => {
        BonusService.setActiveBonusList()
        UserService.checkUserLogin()
        const userSubscription = UserService.getUserProfile().subscribe(
            (data) => {
                setLoading(false)
                setUserData({
                    ...data,
                })
                setUserReady(true)
            }
        )

        const activeBonusSubscription = BonusService.getActiveBonusList().subscribe(
            (data) => {
                if (data === null) {
                    return
                }
                setBonuses(data)
                setBonusesReady(true)

                if (data.length) {
                    data.find((bonusGame) => {
                        if (bonusGame.bonusType === 'W') {
                            setRelatedGameId(bonusGame.gameId)
                        }
                    })
                }
            }
        )

        return () => {
            userSubscription.unsubscribe()
            activeBonusSubscription.unsubscribe()
            UserService.setIsUserLoggedIn()
        }
    }, [])

    const isDataReady = userReady && bonusesReady

    return (
        <Wrapper>
            <NewWithdraw
                product={'casinogo'}
                currentTheme={'dark'}
                userData={userData}
                showTopBar={false}
                customTopBar={({ title, onClose, onBack }) => (
                    <ModalTopBar
                        title={title}
                        customClose={onClose}
                        customBack={onBack}
                    />
                )}
                bonusesData={bonuses}
                onRemove={(bonusAmount) => {
                    ModalService.showModal('REMOVE_BONUS_CONFIRM', {
                        bonusAmount,
                    })
                }}
                transferMoneyHandler={transferMoneyHandler}
                redirectUrl={getRedirectUrl}
                payoutPending={loading}
                dataIsLoaded={isDataReady}
                onClose={() => {
                    ModalService.closeModal()
                }}
                onBack={() => {
                    ModalService.backModal(
                        UrlHistoryService.getModalStack()[0].modalName
                    )
                }}
                onClickReadMore={onClickReadMore}
                onSelectPaymentTypeModal={onSelectPaymentTypeModal}
                onSelectPaymentTypeAction={onSelectPaymentTypeAction}
                showInfoPopup={onClickShowInfoModal}
                showConfirmationPopup={showConfirmationPopup}
                hideConfirmationPopup={() =>
                    ModalService.closeModal('WITHDRAW_CONFIRM_POPUP')
                }
                minLimit={getMinLimit(userData)}
            />
        </Wrapper>
    )
}

export default Withdraw
